(function() {
    'use strict';

    // Prevent swatch requests in Shopify Theme Customizer — avoids 288-480+ HTTP requests
    // that trip rate limits and break editor iframe communication
    if (window.Shopify && window.Shopify.designMode) {
        return;
    }

    var BFS_SWATCH_HANDLES = window.BFS_SWATCH_COLLECTION_HANDLES || [];
    
    function shouldShowSwatches() {
        var pathname = window.location.pathname;
        var isCollectionPage = false;
        for (var i = 0; i < BFS_SWATCH_HANDLES.length; i++) {
            if (pathname.includes('/collections/' + BFS_SWATCH_HANDLES[i])) {
                isCollectionPage = true;
                break;
            }
        }
        if (!isCollectionPage) {
            isCollectionPage = document.querySelector('.bfs-product-card__swatches-wrapper[data-has-swatch="true"]') !== null;
        }
        var isSearchPage = pathname.includes('/search');
        var hasSearchOverlay = document.querySelector('.bfs-search-overlay') !== null || 
                               document.querySelector('#bfs-search-overlay') !== null ||
                               document.querySelector('#bfs-search-results') !== null;
        
        return isCollectionPage || isSearchPage || hasSearchOverlay;
    }
    
    var _swatchMetafieldCache = {};

    // Per-handle deduplication cache for /products/{handle}.js requests.
    // On a collection page with 24 products × 8 swatches, the same handle can be
    // fetched 24+ times. This cache ensures each handle is fetched only once.
    var _productJsCache = {};
    var _productJsPending = {};

    function fetchProductJs(handle) {
        if (_productJsCache[handle] !== undefined) {
            return Promise.resolve(_productJsCache[handle]);
        }
        if (_productJsPending[handle]) {
            return _productJsPending[handle];
        }
        _productJsPending[handle] = fetch('/products/' + handle + '.js')
            .then(function(response) {
                if (!response.ok) return null;
                return response.json();
            })
            .then(function(product) {
                _productJsCache[handle] = product;
                delete _productJsPending[handle];
                return product;
            })
            .catch(function() {
                _productJsCache[handle] = null;
                delete _productJsPending[handle];
                return null;
            });
        return _productJsPending[handle];
    }
    
    function buildMetafieldSwatchMap() {
        var map = {};
        Object.keys(_swatchMetafieldCache).forEach(function(h) {
            if (_swatchMetafieldCache[h]) map[h] = _swatchMetafieldCache[h];
        });
        if (window.BFS_SWATCH_METAFIELD_MAP) {
            Object.keys(window.BFS_SWATCH_METAFIELD_MAP).forEach(function(h) {
                if (window.BFS_SWATCH_METAFIELD_MAP[h]) {
                    map[h] = window.BFS_SWATCH_METAFIELD_MAP[h];
                }
            });
        }
        var allWrappers = document.querySelectorAll('.bfs-product-card__swatches-wrapper[data-product-swatch-url]');
        allWrappers.forEach(function(w) {
            var handle = w.getAttribute('data-product-handle');
            var metaUrl = w.getAttribute('data-product-swatch-url');
            if (handle && metaUrl && metaUrl.trim() !== '') {
                map[handle] = metaUrl;
            }
        });
        return map;
    }
    
    function fetchSwatchMetafieldUrls(handles) {
        var uncached = handles.filter(function(h) {
            return h && !_swatchMetafieldCache.hasOwnProperty(h);
        });
        if (uncached.length === 0) {
            return Promise.resolve(_swatchMetafieldCache);
        }
        var promises = uncached.map(function(handle) {
            return fetch('/products/' + handle + '?sections=swatch-metafield-data')
                .then(function(resp) {
                    if (!resp.ok) return null;
                    return resp.json();
                })
                .then(function(data) {
                    if (data && data['swatch-metafield-data']) {
                        var tempDiv = document.createElement('div');
                        tempDiv.innerHTML = data['swatch-metafield-data'];
                        var url = (tempDiv.textContent || tempDiv.innerText || '').trim();
                        _swatchMetafieldCache[handle] = url || '';
                    } else {
                        _swatchMetafieldCache[handle] = '';
                    }
                })
                .catch(function() {
                    _swatchMetafieldCache[handle] = '';
                });
        });
        return Promise.all(promises).then(function() {
            return _swatchMetafieldCache;
        });
    }
    
    var initSwatchesTimeout = null;
    var lastInitTime = 0;
    var INIT_DEBOUNCE_MS = 500;
    
    function initSwatches() {
        if (!shouldShowSwatches()) {
            return;
        }
        
        var now = Date.now();
        if (now - lastInitTime < INIT_DEBOUNCE_MS) {
            if (initSwatchesTimeout) {
                clearTimeout(initSwatchesTimeout);
            }
            initSwatchesTimeout = setTimeout(function() {
                lastInitTime = Date.now();
                initSwatchesInternal();
            }, INIT_DEBOUNCE_MS);
            return;
        }
        
        lastInitTime = now;
        initSwatchesInternal();
    }
    
    function initSwatchesInternal() {
        var productGrids = document.querySelectorAll(
            '.boost-pfs-filter-products, ' +
            '.CollectionMain, ' +
            '.collection-grid, ' +
            '.bfs-search-results__products-grid, ' +
            '.bfs-search-default__products-grid, ' +
            '.bfs-search-overlay, ' +
            '.ProductList, ' +
            '.ProductList--grid, ' +
            '.ProductList--carousel, ' +
            '.Carousel, ' +
            '.product-recommendations, ' +
            '.swiper, ' +
            '.bfs-slider, ' +
            '.bfs-cards-slider, ' +
            '.bfs-cards-slider__slider-inner, ' +
            '.bfs-tabs-slider, ' +
            '.bfs-media-with-cards'
        );
        if (productGrids.length === 0) {
            if (window.location.pathname.includes('/search')) {
                var searchGrid = document.querySelector('.Grid, .ProductList, main, [class*="search"]');
                productGrids = searchGrid ? [searchGrid] : [document.body];
            } else {
                productGrids = [document.body];
            }
        }
        
        var swatchWrappers = [];
        var isSearchPage = window.location.pathname.includes('/search') || 
                          document.querySelector('.bfs-search-overlay') !== null ||
                          document.querySelector('#bfs-search-overlay') !== null;
        
        productGrids.forEach(function(grid) {
            var allWrappers = grid.querySelectorAll('.bfs-product-card__swatches-wrapper');
            allWrappers.forEach(function(w) {
                var isInitialized = w.hasAttribute('data-initialized');
                var hasSwatches = w.querySelector('.ProductItem__Swatches') && w.innerHTML.trim().length > 50;
                var isEmpty = w.innerHTML.trim() === '' || w.innerHTML.trim().length < 50;
                var isSearchProcessed = w.hasAttribute('data-search-processed');
                
                if (!isInitialized || isEmpty || (isSearchPage && hasSwatches && !isSearchProcessed)) {
                    swatchWrappers.push(w);
                }
            });
        });
        
        if (swatchWrappers.length === 0) {
            return;
        }
        
        var metafieldMap = buildMetafieldSwatchMap();
        
        swatchWrappers.forEach(function(wrapper) {
            var handle = wrapper.getAttribute('data-product-handle');
            
            var hasLiquidSwatches = wrapper.querySelector('.ProductItem__Swatches') && 
                                   wrapper.innerHTML.includes('ProductItem__Swatch') &&
                                   wrapper.innerHTML.trim().length > 50;
            
            var isSearchPage = window.location.pathname.includes('/search') || 
                             document.querySelector('.bfs-search-overlay') !== null ||
                             document.querySelector('#bfs-search-overlay') !== null;
            
            var isSearchProcessed = wrapper.hasAttribute('data-search-processed');
            
            if (hasLiquidSwatches && !isSearchPage) {
                wrapper.setAttribute('data-initialized', 'true');
                return;
            }
            
            if (hasLiquidSwatches && isSearchPage && !isSearchProcessed) {
                wrapper.innerHTML = '';
                wrapper.setAttribute('data-search-processed', 'true');
            } else if (hasLiquidSwatches && isSearchPage && isSearchProcessed) {
                wrapper.setAttribute('data-initialized', 'true');
                return;
            }
            
            wrapper.setAttribute('data-initialized', 'true');
            
            var hasSwatch = wrapper.getAttribute('data-has-swatch');
            var isInCollection = wrapper.getAttribute('data-in-collection');
            var swatchCollectionHandle = wrapper.getAttribute('data-swatch-collection-handle') || '';
            var swatchHandles = wrapper.getAttribute('data-swatch-handles') || '';
            var swatchImagesAttr = wrapper.getAttribute('data-swatch-images') || '';
            var swatchImages = {};
            if (swatchImagesAttr) {
                try {
                    swatchImages = JSON.parse(swatchImagesAttr);
                } catch (e) {
                    swatchImages = {};
                }
            }
            
            Object.keys(metafieldMap).forEach(function(mHandle) {
                swatchImages[mHandle] = metafieldMap[mHandle];
            });
            
            if (!handle) {
                wrapper.innerHTML = '';
                return;
            }
            
            if (isSearchPage) {
                processBoostPFSProduct(wrapper, handle, swatchImages, swatchCollectionHandle);
            } else if (hasSwatch === 'true' && swatchHandles && swatchHandles.trim() !== '') {
                processWithHandles(wrapper, handle, swatchHandles, swatchImages);
            } else if (isInCollection === 'true' || isInCollection === null || isInCollection === '') {
                processBoostPFSProduct(wrapper, handle, swatchImages, swatchCollectionHandle);
            } else {
                wrapper.innerHTML = '';
            }
        });
    }
    
    function hasSwatchColorTag(product) {
        if (!product || !product.tags || !Array.isArray(product.tags)) {
            return false;
        }
        return product.tags.some(function(tag) {
            if (!tag) return false;
            return tag.toLowerCase().indexOf('swatch color:') === 0;
        });
    }
    
    function processWithHandles(wrapper, handle, swatchHandles, swatchImages) {
        var handles = swatchHandles.split(',').filter(function(h) { return h.trim() !== ''; });
        swatchImages = swatchImages || {};

        if (handles.length === 0) {
            return;
        }

        var productPromises = handles.map(function(h) {
            return fetchProductJs(h);
        });

        Promise.all(productPromises).then(function(products) {
            var validProducts = products.filter(function(p) {
                return p !== null && hasSwatchColorTag(p);
            });

            fetchProductJs(handle)
                .then(function(currentProduct) {
                    if (currentProduct && hasSwatchColorTag(currentProduct)) {
                        var alreadyIncluded = validProducts.some(function(p) {
                            return p.handle === handle;
                        });
                        if (!alreadyIncluded) {
                            validProducts.unshift(currentProduct);
                        }
                    }

                    if (validProducts.length > 0) {
                        var allHandles = validProducts.map(function(p) { return p.handle; });
                        fetchSwatchMetafieldUrls(allHandles).then(function(cache) {
                            allHandles.forEach(function(h) {
                                if (cache[h] && cache[h].trim() !== '') {
                                    swatchImages[h] = cache[h];
                                }
                            });
                            renderSwatches(wrapper, validProducts, handle, swatchImages);
                        });
                    }
                })
                .catch(function() {
                    if (validProducts.length > 0) {
                        renderSwatches(wrapper, validProducts, handle, swatchImages);
                    }
                });
        });
    }
    
    function processBoostPFSProduct(wrapper, handle, swatchImages, collectionHandleForProduct) {
        swatchImages = swatchImages || {};
        collectionHandleForProduct = collectionHandleForProduct || '';
        fetchProductJs(handle)
            .then(function(currentProduct) {
                if (!response.ok) {
                    wrapper.innerHTML = '';
                    return null;
                }
                return response.json();
            })
            .then(function(currentProduct) {
                if (!currentProduct) {
                    wrapper.innerHTML = '';
                    return;
                }
                
                var hasTag = hasSwatchColorTag(currentProduct);
                
                if (!hasTag) {
                    wrapper.innerHTML = '';
                    return;
                }
                
                var collectionHandle = collectionHandleForProduct.trim() ||
                    (window.BFS_SWATCH_COLLECTION_HANDLES && window.BFS_SWATCH_COLLECTION_HANDLES[0]) ||
                    'all-mens-aboriginal-art-clothes-australia';
                var allProducts = [];
                var page = 1;
                var productsPerPage = 250;
                var maxPages = 10;

                // Cache for collection JSON responses to avoid redundant pagination fetches
                var _collectionCache = {};

                function fetchCollectionPage(pageNum) {
                    var cacheKey = collectionHandle + ':' + pageNum;
                    if (_collectionCache[cacheKey] !== undefined) {
                        return Promise.resolve(_collectionCache[cacheKey]);
                    }
                    return fetch('/collections/' + collectionHandle + '/products.json?limit=' + productsPerPage + '&page=' + pageNum)
                        .then(function(response) {
                            if (!response.ok) {
                                _collectionCache[cacheKey] = null;
                                return null;
                            }
                            return response.json();
                        })
                        .then(function(data) {
                            _collectionCache[cacheKey] = data;
                            return data;
                        })
                        .catch(function(error) {
                            _collectionCache[cacheKey] = null;
                            return null;
                        });
                }
                
                function fetchAllPages() {
                    fetchCollectionPage(page).then(function(data) {
                        if (!data || !data.products || data.products.length === 0) {
                            processCollectionProducts(allProducts, wrapper, handle, swatchImages);
                            return;
                        }
                        
                        allProducts = allProducts.concat(data.products);
                        
                        if (data.products.length < productsPerPage || page >= maxPages) {
                            processCollectionProducts(allProducts, wrapper, handle, swatchImages);
                        } else {
                            page++;
                            fetchAllPages();
                        }
                    });
                }
                
                fetchAllPages();
            })
            .catch(function(error) {
                wrapper.innerHTML = '';
            });
    }
    
    function processCollectionProducts(products, wrapper, handle, swatchImages) {
        swatchImages = swatchImages || {};
        var validProducts = [];
        products.forEach(function(p) {
            if (p && p.handle && hasSwatchColorTag(p)) {
                validProducts.push(p);
            }
        });
        
        if (validProducts.length === 0) {
            wrapper.innerHTML = '';
            return;
        }
        
        var currentProduct = validProducts.find(function(p) { return p.handle === handle; });
        var otherProducts = validProducts.filter(function(p) { return p.handle !== handle; });
        
        var sortedProducts = [];
        if (currentProduct) {
            sortedProducts.push(currentProduct);
        }
        sortedProducts = sortedProducts.concat(otherProducts.slice(0, 7));
        
        var allHandles = sortedProducts.map(function(p) { return p.handle; });
        fetchSwatchMetafieldUrls(allHandles).then(function(cache) {
            allHandles.forEach(function(h) {
                if (cache[h] && cache[h].trim() !== '') {
                    swatchImages[h] = cache[h];
                }
            });
            renderSwatches(wrapper, sortedProducts, handle, swatchImages);
        });
    }
    
    function renderSwatches(wrapper, products, currentHandle, swatchImages) {
        if (!wrapper) {
            return;
        }
        
        if (products.length === 0) {
            wrapper.innerHTML = '';
            return;
        }
        
        swatchImages = swatchImages || {};
        var swatchSize = 28;
        var swatchesHtml = '<div class="ProductItem__Swatches bfs-product-card__swatches" style="display: flex !important; flex-wrap: wrap; gap: 8px; margin-top: 8px; align-items: center; justify-content: flex-start !important; width: 100%; padding: 0 !important; visibility: visible !important; opacity: 1 !important;">';
        
        products.forEach(function(product) {
            var isCurrent = currentHandle && product.handle === currentHandle;
            var imageUrl = '';
            
            // First, check if we have a pre-rendered swatch image from Liquid (metafield or featured_image)
            if (swatchImages[product.handle]) {
                imageUrl = swatchImages[product.handle];
            } else {
                // Fallback: use product's featured image from API response
                if (product.images && product.images.length > 0) {
                    var firstImage = product.images[0];
                    if (typeof firstImage === 'string') {
                        imageUrl = firstImage;
                    } else if (firstImage && firstImage.src) {
                        imageUrl = firstImage.src;
                    }
                } else if (product.featured_image) {
                    imageUrl = product.featured_image;
                } else if (product.image) {
                    imageUrl = product.image;
                } else if (product.featured_image_url) {
                    imageUrl = product.featured_image_url;
                }
                
                // Process the fallback image URL
                if (imageUrl) {
                    if (typeof imageUrl === 'string') {
                        if (imageUrl.startsWith('//')) {
                            imageUrl = 'https:' + imageUrl;
                        } else if (imageUrl.startsWith('/')) {
                            imageUrl = window.location.origin + imageUrl;
                        }
                        var urlParts = imageUrl.split('?');
                        var baseUrl = urlParts[0];
                        imageUrl = baseUrl + '?width=64&height=64&crop=center';
                    }
                }
            }
            
            var borderColor = isCurrent ? '#156571' : '#d6d6d6';
            var borderWidth = isCurrent ? '2px' : '1px';
            var swatchClass = 'ProductItem__Swatch' + (isCurrent ? ' ProductItem__Swatch--current' : '');
            
            swatchesHtml += '<a href="/products/' + product.handle + '" class="' + swatchClass + '" ' +
                'style="width: ' + swatchSize + 'px; height: ' + swatchSize + 'px; border-radius: 50%; border: ' + borderWidth + ' solid ' + borderColor + '; display: flex !important; align-items: center; justify-content: center; padding: 2px; flex-shrink: 0; transition: border-color 0.2s; visibility: visible !important; opacity: 1 !important;" ' +
                'title="' + (product.title || '').replace(/"/g, '&quot;') + '">' +
                (imageUrl ? '<img src="' + imageUrl + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" ' +
                'style="width: 100%; height: 100%; object-fit: cover; display: block; border-radius: 50%;">' : '') +
                '</a>';
        });
        
        swatchesHtml += '</div>';
        
        if (!document.getElementById('bfs-swatches-styles')) {
            var style = document.createElement('style');
            style.id = 'bfs-swatches-styles';
            style.textContent = 
                '.ProductItem__Swatch:hover { border-color: #156571 !important; } ' +
                '.ProductItem__Swatch--current { border-color: #156571 !important; border-width: 2px !important; } ' +
                '.ProductItem__Swatches, .bfs-product-card__swatches { justify-content: flex-start !important; padding: 0 !important; } ' +
                '@media (max-width: 640px) { .ProductItem__Swatches, .bfs-product-card__swatches { gap: 10px !important; } }';
            document.head.appendChild(style);
        }
        
        wrapper.innerHTML = swatchesHtml;
    }
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            initSwatches();
            if (window.location.pathname.includes('/search')) {
                setTimeout(function() {
                    initSwatches();
                }, 500);
            }
        });
    } else {
        initSwatches();
        if (window.location.pathname.includes('/search')) {
            setTimeout(function() {
                initSwatches();
            }, 500);
        }
    }
    
    window.addEventListener('load', function() {
        if (window.location.pathname.includes('/search')) {
            setTimeout(function() {
                initSwatches();
            }, 300);
        }
        if (document.querySelector('.ProductList--carousel, .Carousel, .swiper.bfs-slider, .bfs-cards-slider, .bfs-tabs-slider')) {
            setTimeout(function() {
                initSwatches();
            }, 350);
        }
    });
    
    document.addEventListener('DOMContentLoaded', function() {
        var observer = new MutationObserver(function(mutations) {
            var shouldReinit = false;
            mutations.forEach(function(mutation) {
                if (mutation.target && mutation.target.closest) {
                    var wrapper = mutation.target.closest('.bfs-product-card__swatches-wrapper');
                    if (wrapper && wrapper.hasAttribute('data-initialized')) {
                        return;
                    }
                }
                
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) {
                        if (node.classList && node.classList.contains('bfs-product-card__swatches-wrapper')) {
                            var isInitialized = node.hasAttribute('data-initialized');
                            if (!isInitialized) {
                                shouldReinit = true;
                            }
                        } else if (node.querySelector && node.querySelector('.bfs-product-card__swatches-wrapper:not([data-initialized])')) {
                            shouldReinit = true;
                        } else if (node.classList && (node.classList.contains('bfs-product-card') || node.classList.contains('Grid__Cell'))) {
                            if (node.querySelector && node.querySelector('.bfs-product-card__swatches-wrapper:not([data-initialized])')) {
                                shouldReinit = true;
                            }
                        } else if (node.classList && (
                            node.classList.contains('boost-pfs-filter-products') || 
                            node.classList.contains('CollectionMain') ||
                            node.classList.contains('bfs-search-results') ||
                            node.classList.contains('bfs-search-results__products-grid') ||
                            node.classList.contains('bfs-search-default__products-grid') ||
                            node.classList.contains('bfs-search-overlay') ||
                            node.classList.contains('ProductList') ||
                            node.classList.contains('ProductList--carousel') ||
                            node.classList.contains('Carousel') ||
                            node.classList.contains('product-recommendations') ||
                            node.classList.contains('swiper') ||
                            node.classList.contains('bfs-slider') ||
                            node.classList.contains('bfs-cards-slider') ||
                            node.classList.contains('bfs-tabs-slider') ||
                            node.classList.contains('bfs-media-with-cards')
                        )) {
                            if (node.querySelector && node.querySelector('.bfs-product-card__swatches-wrapper:not([data-initialized])')) {
                                shouldReinit = true;
                            }
                        } else if (node.classList && (node.classList.contains('Carousel__Cell') || node.classList.contains('swiper-slide'))) {
                            if (node.querySelector && node.querySelector('.bfs-product-card__swatches-wrapper:not([data-initialized])')) {
                                shouldReinit = true;
                            }
                        }
                    }
                });
            });
            
            if (shouldReinit) {
                setTimeout(function() {
                    initSwatches();
                }, 200);
            }
        });
        
        var container = document.body;
        if (container) {
            observer.observe(container, {
                childList: true,
                subtree: true
            });
        }
    });
    
    function clearInitializedFlags() {
        var wrappers = document.querySelectorAll('.bfs-product-card__swatches-wrapper[data-initialized]');
        wrappers.forEach(function(wrapper) {
            var isEmpty = !wrapper.querySelector('.ProductItem__Swatches') || wrapper.innerHTML.trim().length < 50;
            if (isEmpty) {
                wrapper.removeAttribute('data-initialized');
            }
        });
    }
    
    if (typeof window !== 'undefined') {
        window.addEventListener('boost-pfs-filter-products-loaded', function() {
            clearInitializedFlags();
            setTimeout(function() {
                initSwatches();
            }, 300);
            setTimeout(function() {
                initSwatches();
            }, 600);
            setTimeout(function() {
                initSwatches();
            }, 1000);
        });
        
        window.addEventListener('boost-pfs-filter-render-complete', function() {
            clearInitializedFlags();
            setTimeout(function() {
                initSwatches();
            }, 300);
            setTimeout(function() {
                initSwatches();
            }, 600);
            setTimeout(function() {
                initSwatches();
            }, 1000);
        });
        
        window.addEventListener('boost-pfs-filter-tree-loaded-next-page', function() {
            clearInitializedFlags();
            setTimeout(function() {
                initSwatches();
            }, 400);
        });
        
        window.addEventListener('boost-pfs-filter-after-processing', function() {
            clearInitializedFlags();
            setTimeout(function() {
                initSwatches();
            }, 500);
            setTimeout(function() {
                initSwatches();
            }, 1000);
        });
        
        window.addEventListener('bfs-product-recommendations-loaded', function() {
            clearInitializedFlags();
            setTimeout(function() {
                initSwatches();
            }, 100);
            setTimeout(function() {
                initSwatches();
            }, 400);
        });
        
        function setupSearchOverlayWatcher() {
            var searchOverlay = document.querySelector('.bfs-search-overlay') || document.querySelector('#bfs-search-overlay');
            if (searchOverlay) {
                var overlayObserver = new MutationObserver(function(mutations) {
                    mutations.forEach(function(mutation) {
                        if (mutation.type === 'attributes' && (mutation.attributeName === 'aria-hidden' || mutation.attributeName === 'class')) {
                            var isOpen = searchOverlay.getAttribute('aria-hidden') === 'false' || 
                                         searchOverlay.classList.contains('is-open');
                            if (isOpen) {
                                setTimeout(function() {
                                    initSwatches();
                                }, 200);
                                setTimeout(function() {
                                    initSwatches();
                                }, 500);
                                setTimeout(function() {
                                    initSwatches();
                                }, 1000);
                            }
                        }
                    });
                });
                overlayObserver.observe(searchOverlay, {
                    attributes: true,
                    attributeFilter: ['aria-hidden', 'class']
                });
                
                var searchResults = document.querySelector('#bfs-search-results');
                if (searchResults) {
                    var resultsObserver = new MutationObserver(function(mutations) {
                        setTimeout(function() {
                            initSwatches();
                        }, 300);
                    });
                    resultsObserver.observe(searchResults, {
                        childList: true,
                        subtree: true
                    });
                }
            }
        }
        
        setupSearchOverlayWatcher();
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', setupSearchOverlayWatcher);
        }
        
        setTimeout(function() {
            var searchOverlay = document.querySelector('.bfs-search-overlay') || document.querySelector('#bfs-search-overlay');
            if (searchOverlay) {
                var isOpen = searchOverlay.getAttribute('aria-hidden') === 'false' || 
                             searchOverlay.classList.contains('is-open');
                if (isOpen) {
                    initSwatches();
                }
            }
        }, 500);
        
        if (window.location.pathname.includes('/search')) {
            setTimeout(function() {
                initSwatches();
            }, 500);
            setTimeout(function() {
                initSwatches();
            }, 1500);
            setTimeout(function() {
                initSwatches();
            }, 2000);
        }
        
        if (document.readyState === 'complete' && window.location.pathname.includes('/search')) {
            setTimeout(function() {
                initSwatches();
            }, 300);
        }
        
        if (window.location.pathname.includes('/search')) {
            setTimeout(function() {
                initSwatches();
            }, 1500);
            setTimeout(function() {
                initSwatches();
            }, 3000);
        }
    }
    
    window.initSwatches = initSwatches;
    
})();
